import React, { useMemo } from 'react';
import { Icon, toIconsEnum } from 'components/Icons';
import { AnchorLink } from 'components/anchorLink';
import { Tooltip } from 'components/tooltip';
import { isHappybetSite } from 'utility/constant';
import styles from './ScommesseTableWidget.module.scss';

export type ScommesseTableWidgetProps = {
  items: Widget[];
  className?: string;
};

export type Widget = {
  id: string;
  url?: string;
  action?: () => void;
  tooltipContent?: string;
  iconColor?: string;
};

export const ScommesseTableWidget = ({ items, className }: ScommesseTableWidgetProps) => {
  return (
    <ul className={`${styles.container} ${className ? className : ''} ${items.length <= 0 ? styles.emptyList : ''}`}>
      {items &&
        items.map((item: Widget, index: number) => {
          const { id, url, action } = item;
          const objWidget = <WidgetChild widget={item} />;
          return (
            <li className={styles.item} key={id + '_' + index}>
              {url ? (
                <AnchorLink href={url} className={styles.link}>
                  {objWidget}
                </AnchorLink>
              ) : (
                <button className={styles.button} onClick={action}>
                  {objWidget}
                </button>
              )}
            </li>
          );
        })}
    </ul>
  );
};

type WidgetChildProps = {
  widget: Widget;
};

const WidgetChild = ({ widget }: WidgetChildProps) => {
  const { id, tooltipContent } = widget;

  const objDefault = useMemo(() => {
    return (
      <Icon
        iconId={toIconsEnum(id)}
        className={`${id.toUpperCase() === 'BONUS' ? styles.iconSmall : styles.icon}`}
        color={
          id.toUpperCase() === 'BONUS'
            ? 'var(--color-primary)'
            : isHappybetSite && id.toUpperCase() === 'STREAMING'
            ? 'var(--color-accent)'
            : 'var(--color-on-bg-secondary)'
        }
      />
    );
  }, [id]);

  if (id.toUpperCase() === 'TV') {
    return <Tooltip content={tooltipContent!} iconId={id.toUpperCase()} />;
  }

  return objDefault;
};